import { type Common } from '../common.js';
import {
  type CrawlerConfig,
  type CreateValues,
  type FindAllOptions,
  type UpdateValues,
} from '../models/crawlerApi/config.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/crawler/crawler-configs';
  }

  async findAll(options?: FindAllOptions): Promise<CrawlerConfig[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    const { crawlerConfigs } = await this.common.getJSON(url);
    return crawlerConfigs;
  }

  async findOneById(id: string): Promise<CrawlerConfig> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { crawlerConfig } = await this.common.getJSON(url);
    return crawlerConfig;
  }

  async create(values: CreateValues): Promise<CrawlerConfig> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { crawlerConfig } = await this.common.postJSON(url, values);
    return crawlerConfig;
  }

  async update(id: string, values: UpdateValues): Promise<CrawlerConfig> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { crawlerConfig } = await this.common.patchJSON(url, values);
    return crawlerConfig;
  }
}
